/**
 * @description 3个子配置，通用配置|主题配置|网络配置导出
 */
const setting = require('./setting.config')
const theme = require('./theme.config')
const network = require('./net.config')  
// module.exports = { setting, theme, network } 
const data= Object.assign({}, setting, theme, network) 


export default data



// WEBPACK FOOTER //
// ./src/config/index.js